import { getRandomId } from '../utils';
import * as SERVER_MESSAGE_TYPE from './server-type';
export function makeMessage(type, data, needId = true) {
    const result = {
        ...(needId && { id: getRandomId() }),
        ...data,
    };
    return {
        role: 'client',
        type,
        data: result,
    };
}
export function makeUnicastMessage(msg, from, to) {
    return {
        type: SERVER_MESSAGE_TYPE.MESSAGE,
        content: {
            data: msg,
            from,
            to,
        },
    };
}
export function makeBroadcastMessage(msg) {
    return {
        type: SERVER_MESSAGE_TYPE.BROADCAST,
        content: {
            data: msg,
        },
    };
}
